export default "__VITE_ASSET__N7XuSF_r__"